/**
 * Constantes de chaves do localStorage utilizadas pela aplicação
 */

export const STORAGE_KEY_ACCESS = '@nectar/access_token';
export const STORAGE_KEY_REFRESH = '@nectar/refresh_token';
